module.exports = __webpack_public_path__ + "static/media/pmv_blue_circle.be9a55b1.svg";